export enum FlagState {
  Raise = 'raise',
  Edit = 'edit',
  Resolved = 'resolved',
}
